import { useEffect, useState } from "react";
import { DisplayLinksType } from "../../utils/displayLinks";
import { WAProduct } from "../../utils/productType";
import styles from "./Header.module.scss";

type Props = {
  t: (val: string) => string;
  isProductOpen: boolean;
  displayedLinks: DisplayLinksType;
  handleProductOpen: () => void;
  productName: WAProduct;
};

export const ProductList: React.FC<Props> = ({
  t,
  isProductOpen,
  displayedLinks,
  handleProductOpen,
  productName,
}) => {
  const closeWithClickOutSideMethod = (
    e: React.MouseEvent<HTMLUListElement, MouseEvent>,
    handleProductOpen: () => void
  ) => {
    if (e.clientX > 291) {
      //メニューの外側をクリックしたときだけメニューを閉じる
      handleProductOpen();
    }
  };

  const listClassName = `${styles.productList} ${isProductOpen && styles.listOpen}`;

  const analysisParam: string = "?utm_medium=referral&utm_source=wa-snow&utm_campaign=header";

  return (
    <ul
      className={listClassName}
      onClick={(e) => {
        closeWithClickOutSideMethod(e, handleProductOpen);
      }}
    >
      {displayedLinks.top && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.top") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} ${styles.top} icon-wamazing-filled`}></span>
            {t("header.wamazing_top")}
          </a>
        </li>
      )}
      {displayedLinks.yado && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.yado") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-stay`}></span>
            {t("product.stay")}
          </a>
        </li>
      )}
      {displayedLinks.activity && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.activity") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-play`}></span>
            {t("product.play")}
          </a>
        </li>
      )}
      {displayedLinks.snow && (
        <li
          className={`${styles.list} ${styles.currentProduct}`}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.snow") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-snow`}></span>
            {t("product.snow")}
          </a>
        </li>
      )}
      {displayedLinks.ticket && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.ticket") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-transport`}></span>
            {t("product.transport")}
          </a>
        </li>
      )}
      {displayedLinks.kaimono && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.kaimono") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-shop`}></span>
            {t("product.shopping")}
          </a>
        </li>
      )}
      {displayedLinks.discover && (
        <li
          className={styles.list}
        >
          <a
            className={`${styles.anchor}`}
            href={t("links.discover") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-discover`}></span>
            {t("product.discover")}
          </a>
        </li>
      )}
      {displayedLinks.sim && (
        <li className={styles.list}>
          <a
            className={`${styles.anchor}`}
            href={t("links.sim") + analysisParam}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={`${styles.icon} icon-sim`}></span>
            {t("product.sim")}
          </a>
        </li>
      )}

      {/* 台湾当局から違法性の指摘があったため、全リージョンで一時的に保険関連を非表示にする対応
        {displayedLinks.insurance && (
          <li
            className={styles.list}
          >
            <a
              className={`${styles.anchor}`}
              href={t("links.insurance") + analysisParam}
              target="_blank"
              rel="noreferrer noopener"
            >
              <span className={`${styles.icon} icon-insurance`}></span>
              {t("product.insurance")}
            </a>
          </li>
        )}
      */}

      <hr className="mt-1 mx-3 mb-3" />

      {displayedLinks.stayPackage && (
        <li className={`${styles.list} ${styles.stayPackageList}`}>
          <a
            className={`${styles.anchor}`}
            href={`/snow/stay-packages${analysisParam}`}
            rel="noreferrer noopener"
            target="_blank"
          >
            <span className={`${styles.icon} icon-hotel_solid`}></span>
            {t("product.stay_package")}
            <i className={`fas fa-chevron-right ${styles.chevronRight}`} />
          </a>
        </li>
      )}

    </ul>
  );
};
